import { webapi } from '@/api/webapi.ts';
import { cancelStopLoss } from '@/store/orders/stopLoss/api/cancelStopLoss.ts';
import { submitStopLoss } from '@/store/orders/stopLoss/api/submitStopLoss.ts';
import { updateStopLoss } from '@/store/orders/stopLoss/api/updateStopLoss.ts';
import { validateStopLoss } from '@/store/orders/stopLoss/api/validateStopLoss.ts';

export const stopLossOrderApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    validateStopLoss: validateStopLoss(builder),
    submitStopLoss: submitStopLoss(builder),
    cancelStopLoss: cancelStopLoss(builder),
    updateStopLoss: updateStopLoss(builder),
  }),
});

export const {
  useValidateStopLossMutation,
  useSubmitStopLossMutation,
  useCancelStopLossMutation,
  useUpdateStopLossMutation,
} = stopLossOrderApi;
